
import { dispatchSubmitSetLanguage } from '@/store/main/actions';
import { readIsLoggedIn } from '@/store/main/getters';
import { Component, Vue, Prop } from 'vue-property-decorator';


@Component({
  components: {
  },
})
export default class I18nDropdown extends Vue {
  @Prop({default: ''}) public innerClass!: string;
  @Prop({default: false}) public mobile!: boolean;
  public locales = [
    { code: 'en', iso: 'en-US', file: 'en.json', title: 'English' },
    { code: 'ru', iso: 'ru-RU', file: 'ru.json', title: 'Русский' },
    { code: 'pt', iso: 'pt-PT', file: 'pt.json', title: 'Português Europeu' },
    { code: 'pt-br', iso: 'pt-br', file: 'bt-br.json', title: 'Português Brasileiro' },
    { code: 'es', iso: 'es-ES', file: 'es.json', title: 'Español' },
    { code: 'it', iso: 'it-IT', file: 'it.json', title: 'Italiano' },
    { code: 'tuv', iso: 'tyv-RU', file: 'tuv.json', title: 'Тыва дыл' },
  ];

  public async switchLocalePath(locale) {
    this.$root.$i18n.locale = locale;
    await dispatchSubmitSetLanguage(this.$store, {language: locale});
    if (this.isLoggedIn) {
      window.location.reload();
    }
  }
  get isLoggedIn() {
    return readIsLoggedIn(this.$store);
  }
}
